import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["newName", "name"]
  static values = {
    recipeId: Number
  }

  nameTargetConnected() {
    this.reindex()
  }
  
  nameTargetDisconnected() {
    this.reindex()
  }
  
  reindex() {
    let index = 0;
    for (let nameTarget of this.nameTargets) {
      nameTarget.name = `food_recipe[recipe_ingredients_attributes][${index++}][name]`
    }
  }

  add() {
    const ingredientName = this.newNameTarget.value
    const recipeId = this.recipeIdValue

    post(this.url(), {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      },
      body: {
        food_recipe_ingredient: {
          foodRecipeId: recipeId,
          name: ingredientName
        }
      }
    })

    this.newNameTarget.value = ""
  }

  remove(event) {
    const ingredient = event.currentTarget.closest(".ingredient")
    ingredient.remove()
    event.preventDefault()
  }

  url() {
    if(this.recipeIdValue > 0) {
      return `/food/recipes/${this.recipeIdValue}/recipe_ingredients`
    } else {
      return "/food/recipe_ingredients";
    }
  }
}